// extracted by mini-css-extract-plugin
export var dividerLine = "_52-0";
export var errorBackground = "_52-1";